import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUsers, editUser, addUser } from '../actions';
import { ROUTES } from '../actions';
import { saveUser } from '../actions';
import EditUserDrawer from './EditUserDrawer';
import NewUserDrawer from './NewUserDrawer';

// Material UI Library
import { Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import Toggle from 'material-ui/Toggle';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';


class Users extends Component {

  constructor(props) {
    super(props);
    this.state = { open: true };
  }

  componentWillMount() {
    if (!this.props.users.length) {
      this.props.dispatch(fetchUsers());
    }
  }

  handleAdminToggle = (ref, e) => {
    ref.admin = !ref.admin;
    this.props.dispatch(saveUser( { id: ref.id, admin: ref.admin } ));
  };

  handleEditUser = (id) => {
    this.props.dispatch( editUser(id) );
  }

  handleAddUser = () => {
    this.props.dispatch( addUser() );
  }

  render() {
    const styles = {
      root: {
        overflowX: 'hidden',
        position: 'relative',
        minHeight: '93vh',
      },
      adminToggle: {
        width: '2rem',
      },
      actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 10,
      }
    }

    return (
      <div style={styles.root}>
        {this.props.users.filter(user => user.editing).map(user =>
          <EditUserDrawer
            key={user.id}
            user={user}
            isFetching={this.props.isFetching}
          />
        ).splice(0,1)}
        <NewUserDrawer open={this.props.usersList.indexOf(-1) !== -1} />
        <div style={styles.actions}>
          <RaisedButton
            label="Add"
            secondary={true}
            onClick={this.handleAddUser}
          />
        </div>
        <Divider />
        <Table>
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>First Name</TableHeaderColumn>
              <TableHeaderColumn>Last Name</TableHeaderColumn>
              <TableHeaderColumn>Email</TableHeaderColumn>
              <TableHeaderColumn style={styles.adminToggle}>Admin</TableHeaderColumn>
              <TableHeaderColumn></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
          >
            {this.props.users.map(user =>
            <TableRow
              key={user.id}
              selectable={false}
            >
              <TableRowColumn>
                {user.firstName}
              </TableRowColumn>
              <TableRowColumn>{user.lastName}</TableRowColumn>
              <TableRowColumn>{user.email}</TableRowColumn>
              <TableRowColumn style={styles.adminToggle}>
                <Toggle
                  onToggle={this.handleAdminToggle.bind(this, user)}
                  defaultToggled={user.admin}
                />
              </TableRowColumn>
              <TableRowColumn>
                <FlatButton
                  onTouchTap={this.handleEditUser.bind(this, user.id)}
                  label="Edit"
                />
              </TableRowColumn>
            </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    );
  }
}

function visibilityFilter(store) {
  if (!store.get('result').size) return [];

  return store.get('result')
    .filter(id => id !== -1)
    .map(id =>
    store.get('items').get(`${id}`)
  ).toJS();
}

function mapStateToProps(state, props) {
  return {
    users: visibilityFilter(state.get('users')),
    usersList: state.get('users').get('result'),
    isFetching: state.get('users').get('isFetching'),
  };
}

export default connect(mapStateToProps)(Users);



/** WEBPACK FOOTER **
 ** ./containers/Users.js
 **/